import React from "react";
import { TodayTriage } from "@/components/today/TodayTriage";
import { getAdapter } from "@/components/today/todayTriage";

const TYPE_BADGE = {
  overdue_task: "bg-red-100 text-red-700",
  stalled_with_client: "bg-purple-100 text-purple-700",
  stalled_deal: "bg-orange-100 text-orange-700",
  no_contact: "bg-slate-200 text-slate-700",
  content_approval: "bg-indigo-100 text-indigo-700",
  content_overdue: "bg-rose-100 text-rose-700",
  pending_approval: "bg-blue-100 text-blue-700",
  signal: "bg-blue-100 text-blue-700",
};

// ONE row component. Both the Today At Risk strip and the filtered At Risk queue
// render through this, so a filtered item has exactly the capabilities it has on
// Today — same adapter registry, same triage control, no separate mutations.
export function AtRiskRow({ item, idx, api, users, onDone, onOpenClient, onOpenBoard, onOpen, onChase }) {
  const adapter = getAdapter(item);
  const isChase = item.type === "stalled_with_client";
  return (
    <div
      className={`flex items-start justify-between gap-3 bg-white rounded-lg px-3 py-2 border ${item.severity === "high" ? "border-red-200" : item.severity === "medium" ? "border-amber-200" : "border-slate-200"}`}
      data-testid={`at-risk-item-${idx}`}
    >
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 flex-wrap">
          <span className={`text-[10px] font-bold px-1.5 py-0.5 rounded ${TYPE_BADGE[item.type] || "bg-blue-100 text-blue-700"}`}>
            {item.type.replace(/_/g, " ").toUpperCase()}
          </span>
          <span className="text-sm font-semibold text-slate-900 truncate">{item.title}</span>
        </div>
        <p className="text-xs text-slate-500 mt-0.5">
          {item.detail}{item.owner && item.owner !== "unassigned" && ` · ${item.owner}`}
        </p>
      </div>
      {isChase ? (
        <div className="flex items-center gap-1.5 shrink-0">
          <button
            onClick={() => onChase && onChase(item)}
            className="text-[11px] font-semibold px-2 py-1 rounded bg-purple-600 text-white hover:bg-purple-700 transition-colors"
            data-testid={`at-risk-chase-${idx}`}
          >Draft chase email</button>
          <button
            onClick={() => (onOpenBoard ? onOpenBoard() : null)}
            className="text-[11px] px-2 py-1 rounded border border-slate-200 text-slate-600 hover:bg-slate-50 transition-colors"
            data-testid={`at-risk-open-task-${idx}`}
          >Open task</button>
        </div>
      ) : adapter ? (
        <TodayTriage
          item={item}
          adapter={adapter}
          api={api}
          users={users}
          idx={idx}
          onDone={onDone}
          onOpenClient={onOpenClient}
          onOpenBoard={onOpenBoard}
          onOpen={onOpen}
        />
      ) : (
        // null adapter = an item type no adapter has registered yet.
        <span className="text-[11px] text-slate-400 shrink-0" data-testid={`at-risk-unregistered-${idx}`}>No handler yet</span>
      )}
    </div>
  );
}
